import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  TableContainer,
} from '@material-ui/core';
import { useStyles, StyledTableCell } from '../../adminStyles';
const DefaultersTable = props => {
  const {
    sortLabel,
    tableRoot,
    tableContainer,
    customHeaderCont,
    tableHeaders,
  } = useStyles();

  const { columns, rows, sortArray, orderAscending, orderBy, asc, searchTerm } = props;

  const renderStyledTableCell = () =>
    columns.map(column =>
      column.id === 'name' ||
      column.id === 'hours' ||
      column.id === 'status' ||
      column.id === 'fromDate' ||
      column.id === 'toDate' ? (
        <StyledTableCell
          key={column.id}
          align='center'
          padding={column.disablePadding ? 'none' : 'default'}
          sortDirection={orderBy === column.id ? orderAscending : false}
        >
          <TableSortLabel
            active={orderBy === column.id}
            direction={asc}
            onClick={sortArray(rows, column.id)}
            className={sortLabel}
          >
            {column.label}
          </TableSortLabel>
        </StyledTableCell>
      ) : (
        <StyledTableCell
          key={column.id}
          align='center'
          padding={column.disablePadding ? 'none' : 'default'}
        >
          {column.label}
        </StyledTableCell>
      )
    );

  const renderTableBody = () =>
    rows
      .filter(row => row.name.toLowerCase().includes(searchTerm.toLowerCase()))
      .map((row, i) => {
        return (
          <TableRow tabIndex={-1} key={row.code}>
            {columns.map(column => {
              const value = row[column.id];
              return (
                <TableCell key={column.id} align='center'>
                  {column.id === 'status' ? value : null}
                  {column.id === 'fromDate' ? value : null}
                  {column.id === 'toDate' ? value : null}
                  {column.id === 'name' ? value : null}
                  {column.id === 'hours' ? value : null}
                </TableCell>
              );
            })}
          </TableRow>
        );
      });

  const renderTableHeader = () => {
    return (
      <div className={customHeaderCont}>
        <div align='left' className={tableHeaders}>
          No Of Employees:
          <span style={{ color: '#42ADE2' }}>
            {
              rows
                .filter(row => row.name.toLowerCase().includes(searchTerm.toLowerCase()))
                .filter(function (obj) {
                  return obj.empType === 'fulltime';
                }).length
            }
          </span>
        </div>
        <div align='left' className={tableHeaders}>
          No Of Contractors:
          <span style={{ color: '#42ADE2' }}>
            {
              rows
                .filter(row => row.name.toLowerCase().includes(searchTerm.toLowerCase()))
                .filter(function (obj) {
                  return obj.empType === 'contractor';
                }).length
            }
          </span>
        </div>
      </div>
    );
  };

  return (
    <Paper className={tableRoot}>
      <TableContainer className={tableContainer}>
        <TableRow>{renderTableHeader()}</TableRow>
        <Table stickyHeader>
          <TableHead>
            <TableRow>{renderStyledTableCell()}</TableRow>
          </TableHead>
          <TableBody>{renderTableBody()}</TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default DefaultersTable;
